import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';

import style from './index.module.scss';

function UserInfo({ user, dates }) {
  const { row, img, info, name, date } = style;

  const formattedAnswerDate = () => {
    if (dates.createdAt === dates.updatedAt) {
      return `Added ${moment(dates.createdAt).format('LL')}`;
    } else {
      return `Updated ${moment(dates.updatedAt).format('LL')}`;
    }
  };

  return (
    <div className={`row ${row}`}>
      <Link
        to={{
          pathname: `/account/${user.fullname}`,
          state: {
            userId: user.id,
          },
        }}
      >
        <img
          src={user.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'}
          alt={user.fullname}
          className={img}
        />
      </Link>
      <div className={`row`}>
        <div className={`col-12 ${info}`}>
          <p className={name}>
            <Link
              to={{
                pathname: `/account/${user.fullname}`,
                state: {
                  userId: user.id,
                },
              }}
              className={style['name-link']}
            >
              {user.fullname}
            </Link>
            {user.bio && <span>, {user.bio}</span>}
          </p>
          <p className={date}>{formattedAnswerDate()}</p>
        </div>
      </div>
    </div>
  );
}

UserInfo.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fullname: PropTypes.string.isRequired,
    bio: PropTypes.string,
  }),
  dates: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }).isRequired,
};

export default UserInfo;
